import * as React from 'react';
import './slideover.scss';

export interface ISlideoverProps {
    className?: string;
    panelCenter: React.ReactNode;
    panelLeft: React.ReactNode;
    panelRight: React.ReactNode;
    isSlid: () => boolean;
}

export class Slideover extends React.Component <ISlideoverProps> {
    constructor(props: ISlideoverProps) {
        super(props);
    }

    render(): React.ReactNode {
        const { isSlid, panelCenter, panelLeft, panelRight } = this.props;
        const className = this.props.className || '';

        return (
            <div className={`slideover ${isSlid() ? 'slideover--has-slid' : ''} ${className}`}>
                <div className="slideover__main">
                    <div className="slideover__main-left">{panelLeft}</div>
                    <div className="slideover__main-center">{panelCenter}</div>
                </div>
                <div className="slideover__right">
                    {panelRight}
                </div>
            </div>
        );
    }
}

export default Slideover;